// Dependencies
import React, {useState} from 'react';

// Styles
import '../../../App.css';
import './ContactForm.css';
import { FileInputField } from '../../../components/fields/FileInputField';
import axios from 'axios';

// Components

// Sections

async function sendEmail(data, files) {
    const formData = new FormData();

    formData.append("clientName", data.name);
    formData.append("clientEmail", data.email);
    formData.append("clientMessage", `
        Name: ${data.name}
        Email: ${data.email}
        Title: ${data.title}

        Message:
        
        ${data.message}
    `);

    for (const file of files) {
        formData.append("files", file);
    }

    return axios.post(
        "https://artisanavisuals.com/api/send-email",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
}

function ContactForm() {
    const [senderName, setName] = useState('');
    const [senderEmail, setEmail] = useState('');
    const [projectTitle, setTitle] = useState('');
    const [senderMessage, setMessage] = useState('');

    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState("")

    const clearStates = () => {
        setName('')
        setEmail('')
        setTitle('')
        setMessage('')

        setFiles([])
    }

    const send = (event) => {
        event.preventDefault();

        setLoading("spinner")

        sendEmail(
            {
                name : senderName,
                email : senderEmail,
                title : projectTitle,
                message : senderMessage 
            }, 
            files
        ).then(() => {
            setLoading("success");
        }).catch(error => {
            setLoading("failure");
        }).finally(() => {
            clearStates()
        });
    }

    return (
        <div className='contact-form-container'>
            {
                loading && <div className='upload-overlay'>
                    { loading === "spinner" && <div className="loader"></div> }
                    { 
                        loading === "success" && 
                        <div className="dialog-wrapper">
                            <div className="dialog">
                                <figure type={loading}>
                                    <i className="fa-solid fa-check" />
                                </figure>
                                <div>
                                    <h1>Order Created</h1>
                                    <p>Your order has been successfully created! We will contact you as soon as possible.</p>
                                </div>
                                <button onClick={() => setLoading("")}>Continue</button>
                            </div>
                        </div> 
                    }
                    { loading === "failure" && 
                        <div className="dialog-wrapper">
                            <div className="dialog">
                                <figure type={loading}>
                                    <i className="fa-solid fa-x" />
                                </figure>
                                <div>
                                    <h1>Error Creating Order</h1>
                                    <p>Your order has not been created! Please try again.</p>
                                </div>
                                <button onClick={() => setLoading("")}>Continue</button>
                            </div>
                        </div> 
                    }
                </div>
            }
            <div className='contact-form-wrapper'>
                <form className='contact-form-form'>
                    <h1 className='contact-form-title' >Send Us a Message</h1>

                    <div className='contact-form-content-wrapper'>
                        <div className='contact-form-content-info'>
                            <input value={senderName} required className='contact-form-info-field' type="text" name="name" placeholder="Your Name" onChange={e => setName(e.target.value)} />
                            <input value={senderEmail} required className='contact-form-info-field' type="email" name="email" placeholder="Your Email" onChange={e => setEmail(e.target.value)} />
                            <input value={projectTitle} className='contact-form-info-field' type="text" name="title" placeholder="Project Title" onChange={e => setTitle(e.target.value)} />
                        </div>

                        <div className='contact-form-content-message-wrapper'>
                            <textarea value={senderMessage} className='contact-form-message-field' type="text" name="message" placeholder="Your Message" onChange={e => setMessage(e.target.value)} />
                        </div>
                    </div>
                    <FileInputField files={files} setFiles={setFiles} />
                    <div className='contact-form-button-wrapper'>
                        <button className='contact-form-submit-button' onClick={send} >Send Message</button>
                    </div>
                </form>
                <div className='contact-form-contact-info'>
                    <h1 data-aos="fade-right" >Contact Info</h1>
                    <div className='contact-form-contact-info-content'>
                        <div data-aos="fade-up" data-aos-delay={300} >
                            <p>Thank you for your interest in ArtisanaVisuals</p>
                            <p>We are here to help!</p>
                            <p>Please feel free to reach out to us using the contact information.</p>
                            <p>We'll respond to your inquiry as soon as possible.</p>
                        </div>
                        <div>
                            <div data-aos="fade-up" data-aos-delay={700} className='contact-form-contact-info-row'>
                                <h3>Address:</h3>
                                <p>Dr. Janka Bulika 98</p>
                            </div>
                            <div data-aos="fade-up" data-aos-delay={1200} className='contact-form-contact-info-row'>
                                <h3>City:</h3>
                                <p>Kovacica</p>
                            </div>
                            <div data-aos="fade-up" data-aos-delay={1700} className='contact-form-contact-info-row'>
                                <h3>Email:</h3>
                                <p>artisanavisuals@gmail.com</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactForm;